import styled from "styled-components";

export const WaterMark = styled.img`
	page-break-after: always;
	counter-increment: page;
`;

export const TableContainer = styled.table`
	position: relative;
	width: 100%;
	page-break-after: always;
	width: 100%;

	table {
		width: 100%;
	}

	> thead {
		display: table-header-group;
	}
	> tfoot {
		display: table-footer-group;
	}

	div.footer-info,
	div.page-footer {
		display: none;
		height: 40px;
	}

	div.page-footer {
		text-align: right;
		font-size: 10px;
		opacity: 0.8;
		position: fixed;
		bottom: 0;
		right: 0;
		left: 0;
		width: 100%;
	}
	@media print {
		@page {
			size: A4;
			margin: 8mm 8mm 8mm 8mm;
		}
		div.page-footer,
		div.footer-info {
			display: block;
		}
	}
`;
